import { createFileRoute } from '@tanstack/react-router';
import { OrderlessLayout } from '../../layouts/Orderless/OrderlessLayout';

export const Route = createFileRoute('/$retailer/orderless')({
  component: OrderlessLayout,
});
